import { AccessItem } from "features/EmployeesGroupModal/EmployeesGroupModal";

import { Checkbox } from "components/Checkbox/Checkbox";
import { Divider } from "components/Divider/Divider";
import { MediumText } from "components/MediumText/MediumText";
import { Paragraph } from "components/Paragraph/Paragraph";
import { Row } from "components/Row/Row";

import styles from "./styles.module.css";

type Props = {
  accessList: AccessItem[];
  checkedAccessList: string[];
  onChange: (accessid: string) => void;
};

export function AccessList({ accessList, checkedAccessList, onChange }: Props) {
  return (
    <div>
      <Row>
        <div className="flex flex-1 gap-6 items-center">
          <MediumText style={{ width: "20px" }}>№</MediumText>
          <MediumText style={{ width: "60px" }}>Доступно</MediumText>
          <MediumText>Действие</MediumText>
        </div>
      </Row>
      <Divider />
      {accessList?.map((item: any) => (
        <Row
          key={item.accessid}
          onClick={() => onChange(item.accessid)}
          className={`hoverBg cursor-pointer ${checkedAccessList.includes(item.accessid) ? styles.isActive : ""}`}
        >
          <div className="flex flex-1 gap-6 items-center">
            <Paragraph width={20}>{item.accessid}</Paragraph>
            <Checkbox
              checked={checkedAccessList.includes(item.accessid)}
              wrapperWidth={60}
              // onClick={(ev) => console.log(ev.isPropagationStopped())}
            />
            <Paragraph>{item.name}</Paragraph>
          </div>
        </Row>
      ))}
    </div>
  );
}
